// Helpers for remembering the page a user was trying to reach before they were
// sent to the Auth0 login flow, so we can return them there afterwards.
//
// The value is stored in `sessionStorage` (per-tab, survives the full-page
// redirect to Auth0 and back). The route guard writes the intended destination
// on every protected navigation; `main.ts` reads and clears it once, only when
// the app boots from an Auth0 redirect callback.
export const RETURN_TO_KEY = 'auth:returnTo';

export function rememberReturnTo(path: string): void {
        try {
                sessionStorage.setItem(RETURN_TO_KEY, path);
        } catch {
                // sessionStorage can be unavailable (private mode / disabled);
                // failing to remember the target is non-fatal — the user simply
                // lands on the default page after login.
        }
}

export function consumeReturnTo(): string | null {
        try {
                const value = sessionStorage.getItem(RETURN_TO_KEY);
                sessionStorage.removeItem(RETURN_TO_KEY);
                return value;
        } catch {
                return null;
        }
}
